export default "__VITE_ASSET__Cis4vpMq__"